import * as Config from '@/Config';

/**
 * Actions are asynchronous operations that can commit mutations.
 * They can contain arbitrary asynchronous operations.
 *
 * @see https://vuex.vuejs.org/guide/actions.html
 *
 * @class Actions
 * @package Store/Module/VersionHistory
 * @project ChalkySticks App
 */
const actions = {
	/**
	 * Initialize version tracking on app start.
	 * Records the current version and updates lastSeenVersion if this is an upgrade.
	 *
	 * @param object context
	 * @return void
	 */
	initialize({ commit, state }: any): void {
		const currentVersion = Config.App.VERSION;
		const seenVersions = state.seenVersions as string[];
		const isNewVersion = !seenVersions.includes(currentVersion);

		if (isNewVersion) {
			// If we have previous versions, set the most recent as lastSeenVersion
			if (seenVersions.length > 0) {
				const previousVersion = seenVersions[seenVersions.length - 1];
				commit('setLastSeenVersion', previousVersion);
			}

			// Add current version to seen list
			commit('addSeenVersion', currentVersion);
			commit('recordVersionFirstSeen', {
				timestamp: Date.now(),
				version: currentVersion,
			});
		}
	},
};

export default actions;
